export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6330.d3235d19.jpg";